<div class="overlay-form about-bidding-container">
    <div class="header-content d-flex align-items-center justify-content-between">
        <h1>What is product bidding?</h1>
        <img (click)="ref.close()" src="/assets/images/close.svg" class="clickable" />
    </div>
    <div class="overlay-content about-bidding-content">
        <p class="mb-4">
            Bidding is an offer to set a price tag by an individual or business for a product or service
            or a demand that something be done. Bidding is used to determine the cost or value of
            something. Bidding can be performed by a person under influence of a product or service based
            on the context of the situation.
        </p>

        <h2>
            How bidding works on
            {{ storeConfiguration?.display_name || storeConfiguration?.name }}
        </h2>

        <p class="mb-4">
            User has three bidding chances in one turn. The user need to enter his/her bidding offer in
            the dialog box. If the amount gets approved from our end the user can add this product for the
            bidding amount to his/her cart . If user fails to bid an appropriate amount or the three
            chances get used up, he/she needs to start over again.
        </p>

        <div class="tip-container">
            <h2>Tip</h2>

            <p>
                A bid is a legally binding deal, so keep that in mind and place a bid which will help you
                win your desired product.
            </p>
        </div>
    </div>
</div>